import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'stringJoin'})
export class StringJoinPipe implements PipeTransform {
  transform (input: string[], key: string = '-'): string {
      //return input.map(value => value[key]);
      return [...input].reverse().join(` ${key} `);
  }
}